import { render, staticRenderFns } from "./CasePaymentInfos.vue?vue&type=template&id=3210b170"
import script from "./CasePaymentInfos.vue?vue&type=script&lang=js"
export * from "./CasePaymentInfos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports